import { render, staticRenderFns } from "./ButtonAddUserTable.vue?vue&type=template&id=4503e622&scoped=true"
import script from "./ButtonAddUserTable.vue?vue&type=script&lang=js"
export * from "./ButtonAddUserTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4503e622",
  null
  
)

export default component.exports